import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const log = createCrudVuexModule({
  namespaced: true,
  path: "/log",

  actions: {
    async deleteAll() {
      await rest.delete("/log/deleteAll");
    },
  },
});
